/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Consent_House_Rules_LinkInputs */

const en_checkout_consent_house_rules_link = /** @type {(inputs: Checkout_Consent_House_Rules_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House Rules`)
};

/**
* | output |
* | --- |
* | "House Rules" |
*
* @param {Checkout_Consent_House_Rules_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_consent_house_rules_link = /** @type {((inputs?: Checkout_Consent_House_Rules_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Consent_House_Rules_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_consent_house_rules_link(inputs)
});